import AbstractChannel from './AbstractChannel'

export default class SpotHero extends AbstractChannel {

  name = 'spothero'
  title = 'SpotHero'
  titleShort = 'SpotHero'
  color = '#2077b4'

  supportedFeatures = ['blackouts']

}
